import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type RentalExtension = {
  rental_extension_id?: number; // 렌탈 연장신청 idx
  rental_id?: number; // 렌탈 idx
  rental_extension_date?: { [key: string]: string | number }; // 렌탈 연장 시작일/종료일
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] RentalExtension
   * --
   */
  getRentalExtensions: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_RENTAL_EXTENSION, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] RentalExtension
   * --
   */
  getRentalExtension: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_RENTAL_EXTENSION, {
        rental_extension_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] RentalExtension
   * --
   */
  createRentalExtension: async (body: RentalExtension) => {
    try {
      const res = await $http.post(APIConstant.CREATE_RENTAL_EXTENSION, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] RentalExtension
   * --
   */
  updateRentalExtension: async (body: RentalExtension) => {
    try {
      const { rental_extension_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_RENTAL_EXTENSION, {
        rental_extension_id: rental_extension_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] RentalExtension
   * --
   */
  deleteRentalExtension: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_RENTAL_EXTENSION, {
        rental_extension_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
